import {FC} from 'react';
import Image from 'next/image';

import Logos from '../../../Logos';
import {getFooterSecureClassName} from '../../utils';

import {LayoutFooterMobileProps} from './types';

import styles from '../../styles.module.scss';

const LayoutFooterMobile: FC<LayoutFooterMobileProps> = ({
  show,
  currentStep,
}) => {
  if (!show) return null;

  return (
    <div className={styles.stepWrapper__footerMobile}>
      <div className={getFooterSecureClassName(currentStep)}>
        <Image
          width={20}
          height={20}
          src="/static/svg/blue-lock-outline.svg"
          alt="Secure information icon"
        />

        <p> Your information is secure. </p>
      </div>

      <Logos />
    </div>
  );
};

export default LayoutFooterMobile;
